<template>
  <a :href="program.link" target="_blank">
    <div class="program">
      <figure class="program-thumbnail">
        <div class="thumbnail">
          <img
            :src="program.thumbnail"
            :alt="program.title"
          >
        </div>
        <figcaption v-if="program.start">
          <div
            class="time"
            :class="{'program-onair': onair}"
          >
            <template v-if="onair">
              LIVE配信中
            </template>
            <template v-else>
              {{ program.start }}〜{{ program.end }}
            </template>
          </div>
        </figcaption>
      </figure>
      <div class="program-detail">
        <div class="program-title">
          <Title>
            <template #icon>
              <img src="/img/instagram.png" alt="">
            </template>
            <template #title>
              {{ program.title }}
            </template>
          </Title>
        </div>
        <p
          v-html="program.description"
          v-if="program.description"
        />
      </div>
    </div>
  </a>
</template>

<script>
import Title from '@/components/atoms/Title.vue'

export default {
  props: {
    program: {
      type: Object,
      required: true
    },
    onair: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Title
  }
}
</script>

<style lang="sass" scoped>
a
  display: block
  color: $black
.program
  border-radius: 8px
  overflow: hidden
  box-shadow: 0 2px 8px rgba(0, 0, 0, .2)
  .program-thumbnail
    position: relative
    figcaption
      position: absolute
      left: 15px
      bottom: 15px
      .time
        color: #fff
        background-color: $green
        padding: 4px 10px
        border-radius: 20px
        font-size: 1.4rem
        &.program-onair
          background-color: $poppink
  .program-detail
    padding: 15px
    .program-title
      /deep/ .icon
        width: 20px
        height: 20px
        margin-right: 10px
    p
      margin-top: 10px
      text-align: justify
      line-height: 1.6
      font-size: 1.2rem
</style>
